import { RecurringInvoiceStatus } from '../../../enums/recurringInvoiceStatus'

export const recurringInvoiceStatusToTitleKey: Record<RecurringInvoiceStatus, string> = {
  [RecurringInvoiceStatus.Active]: 'legacy_recurring_invoices.status.active',
  [RecurringInvoiceStatus.All]: 'legacy_recurring_invoices.status.all',
  [RecurringInvoiceStatus.Failing]: 'legacy_recurring_invoices.status.failing',
  [RecurringInvoiceStatus.Inactive]: 'legacy_recurring_invoices.status.inactive',
}
